<template>
    <!-- Pregunta dónde aplicar un cambio: solo este alojamiento o todos los del
         anfitrión. Se usa con `await this.$refs.alcance.preguntar(id)`, que
         devuelve 'este' | 'anfitrion' | null (cancelado). -->
    <b-modal ref="modal" :title="$t('admin_tools.scope.title')" centered @hidden="cerrar(null)">
        <div class="hf-scope">
            <button type="button" class="hf-scope__opt" @click="cerrar('este')">
                <i class="fas fa-home" aria-hidden="true" />
                {{ $t('admin_tools.scope.this') }}
            </button>
            <button type="button" class="hf-scope__opt" :disabled="total === null" @click="cerrar('anfitrion')">
                <i class="fas fa-layer-group" aria-hidden="true" />
                <span v-if="total === null"><b-spinner small /></span>
                <span v-else>{{ $t('admin_tools.scope.all', { n: total }) }}</span>
            </button>
            <p class="hf-scope__note">{{ $t('admin_tools.scope.note') }}</p>
        </div>
        <template #modal-footer>
            <button type="button" class="hf-scope__cancel" @click="cerrar(null)">{{ $t('admin_tools.confirm.cancel') }}</button>
        </template>
    </b-modal>
</template>

<script>
import axios from 'axios';
import apiUrls from '@/new-constants/apiUrls';

export default {
    name: 'AdminAlcanceModal',
    data() {
        return { total: null, resolver: null };
    },
    methods: {
        preguntar(idalojamiento) {
            this.total = null;
            this.$refs.modal.show();
            axios.get(apiUrls.backofficeAccommodationScope(idalojamiento))
                .then(({ data }) => { this.total = Number(data.total) || 1; })
                .catch(() => { this.total = 1; });
            return new Promise(resolve => { this.resolver = resolve; });
        },
        cerrar(valor) {
            const r = this.resolver;
            this.resolver = null;
            if (this.$refs.modal) this.$refs.modal.hide();
            if (r) r(valor);
        },
    },
};
</script>

<style scoped lang="scss">
.hf-scope {
    display: flex;
    flex-direction: column;
    gap: 10px;

    &__opt {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        padding: 12px 14px;
        border: 1.5px solid $grey-10;
        border-radius: 10px;
        background: #fff;
        font-weight: 700;
        text-align: left;
        color: $hf-sec-pine;
        cursor: pointer;
        &:hover:not(:disabled) { border-color: $hf-sec-pine; background: #F4F8F6; }
        &:disabled { opacity: .6; cursor: wait; }
        &:focus-visible { outline: 2px solid #2563EB; outline-offset: 2px; }
    }
    &__note { margin: 4px 0 0; font-size: .85rem; color: #6B7280; }
    &__cancel {
        padding: 7px 14px;
        border: 1.5px solid $grey-10;
        border-radius: 8px;
        background: #fff;
        font-weight: 700;
        color: #374151;
    }
}
</style>
